module.exports = __webpack_public_path__ + "img/mx.2e336770.svg";